import { createSelector } from 'utils/app.util';

export const getFacilityProjectsFromState = createSelector(
  (state) => state.getIn(['entity', 'facilities', 'facilityProjects', 'data']),
  (projects) => projects,
);
